import { render, staticRenderFns } from "./manualsdc.vue?vue&type=template&id=c22614b8&scoped=true&"
import script from "./manualsdc.vue?vue&type=script&lang=js&"
export * from "./manualsdc.vue?vue&type=script&lang=js&"
import style0 from "./manualsdc.vue?vue&type=style&index=0&id=c22614b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22614b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c22614b8')) {
      api.createRecord('c22614b8', component.options)
    } else {
      api.reload('c22614b8', component.options)
    }
    module.hot.accept("./manualsdc.vue?vue&type=template&id=c22614b8&scoped=true&", function () {
      api.rerender('c22614b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualsdc.vue"
export default component.exports